import * as types from '../constants/ActionTypes'

const initalState = {
  list: [],
  form: {},
  page: 1,
  selectData: {},


  tmpPage: 1,
  tmpForm: {},
}


const master = (state = initalState, action) => {
  
  switch (action.type) {
    case types.REDUCER_YOSANHISTORYLIST_INIT:
    case types.REDUCER_YOSANHISTORYLIST_SET_SEARCH_RESULT:
    case types.REDUCER_YOSANHISTORYLIST_FORM_CLEAR:
      return Object.assign({}, state, action.payload)
    default:
      return state
  }
}

export default master


// WEBPACK FOOTER //
// ./src/reducers/yosanHistoryList.js